import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    fetchEnrollCourses,
    fetchTopicData,
    fetchUnitData
} from '../../Firebase/Course-fb';
import { sortData } from '../../Helper/Calculation';
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';
import Datanotfound from '../../Helper/Datanotfound';
import {
    getUserDocId,
    isLoggedIn
} from '../../Localstorage';

const Enrolltopic = () => {

    const location = useLocation();
    const { topic_filter, filteredEnrollUnit } = location.state || {};
    // const subject_code = location.state;
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(false);
    const [loading, setLoading] = useState(true);
    const [enroll, setEnroll] = useState([]);

    // Fetch enrollment data
    useEffect(() => {
        const fetchEnrollment = async () => {
            if (isLoggedIn()) {
                try {
                    const userId = getUserDocId();
                    const enrolData = await fetchEnrollCourses(userId);
                    setEnroll(enrolData[0]?.course_list || []);
                    setLoading(false)
                } catch (error) {
                    console.error("Error fetching enrolled courses:", error);
                }
            }
        };

        fetchEnrollment();
    }, []);

    // Fetch unit data and topic list
    useEffect(() => {

        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, [enroll]);

    // Navigation handler
    const handleToSubTopic = async (unit_code) => {
        const found = filteredEnrollUnit.includes(unit_code);
        const unit = await fetchTopicData(unit_code);
        const unit_filter = sortData(unit);
        navigate('/subTopic', { state: { unit_filter, found } });
    };

    // Loading state
    if (loading) {
        return (
            <div className='course_container'>
                <div className="loader">
                    Loading topics...
                    <div className="spinner" />
                    {/* Replace with a spinner component if you prefer */}
                </div>
            </div>
        );
    }

    // No data
    if (!topic_filter || topic_filter.length === 0) {
        return <Datanotfound />;
    }

    return (
        <div className='course_container'>
            <h2>Units</h2>
            <div className='course_inner_container'>
                {topic_filter.map((item) => (
                    <div
                        key={item.unit_code}
                        className='course_card subject'
                        onClick={() => handleToSubTopic(item.unit_code)}
                    >
                        <img
                            className='course_card_img'
                            src={item.unit_image}
                            alt={item.unit_name}
                        />
                        <div
                            className={`heading sub ${item.unit_name.length > (isMobile ? 17 : 20)
                                ? 'long-text'
                                : ''
                                }`}
                        >
                            <span>{item.unit_name}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Enrolltopic